import { render, staticRenderFns } from "./review.vue?vue&type=template&id=25363253"
import script from "./review.vue?vue&type=script&lang=ts"
export * from "./review.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiModal: require('/vercel/path0/components/ui/modal.vue').default,UiIconStarEmpty: require('/vercel/path0/components/ui/icon/star-empty.vue').default,UiIconInfo: require('/vercel/path0/components/ui/icon/info.vue').default,ChefReviewCard: require('/vercel/path0/components/chef/review-card.vue').default})
